import { render, staticRenderFns } from "./QuotedParts.vue?vue&type=template&id=33b84cbb"
import script from "./QuotedParts.vue?vue&type=script&lang=js"
export * from "./QuotedParts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33b84cbb')) {
      api.createRecord('33b84cbb', component.options)
    } else {
      api.reload('33b84cbb', component.options)
    }
    module.hot.accept("./QuotedParts.vue?vue&type=template&id=33b84cbb", function () {
      api.rerender('33b84cbb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/purchaseorder/components/QuotedParts.vue"
export default component.exports